import { render, staticRenderFns } from "./AppMenu.vue?vue&type=template&id=62f74e6b&scoped=true"
import script from "./AppMenu.vue?vue&type=script&lang=js"
export * from "./AppMenu.vue?vue&type=script&lang=js"
import style0 from "./AppMenu.vue?vue&type=style&index=0&id=62f74e6b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f74e6b",
  null
  
)

export default component.exports